// axios
import axios from "axios";
// @ts-ignore
import Cookies from "js-cookie";

export const CheckOtpCode = async (data: any) => {
    let token = Cookies.get('first_token');
    let ClientOption: any = {
        headers: {
            'APIKEY': process.env.REACT_APP_API_CLIENT_KEY,
            Authorization: `Bearer ${token}`,
        }
    };
    const { data: response } = await axios.post(`${process.env.REACT_APP_API_URL}user/check-otp`, data, ClientOption);
    return response.data;
}